module.exports = __webpack_public_path__ + "static/media/riverSketch1.49766aa2.png";